<form [formGroup]="form" (ngSubmit)="save()">
    <div class="form-row">
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="sector" class="form-control" [placeholder]="'Sector'">
            <label>Sector</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="date" formControlName="desde" class="form-control" [placeholder]="'Ingrese desde'">
            <label>Desde</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="date" formControlName="hasta" class="form-control" [placeholder]="'Ingrese hasta'">
            <label>Hasta</label>
        </div>
        <div class="form-field flex-grow-1 mt-1">
            <p-dropdown formControlName="tipoEstado" [options]="tipoEstadoOptions" optionLabel="label"
                optionValue="value" placeholder="Seleccione tipo estado">
            </p-dropdown>
            <label>Tipo Estado</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="responsable" class="form-control"
                [placeholder]="'Responsable'">
            <label>Responsable</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="date" formControlName="fechaNota" class="form-control"
                [placeholder]="'Ingrese fecha nota'">
            <label>Fecha Nota</label>
        </div>
        <div class="form-field flex-grow-1">
            <input pInputText type="text" formControlName="fuente" class="form-control"
                [placeholder]="'Ingrese fuente'">
            <label>Fuente</label>
        </div>
        <div class="form-field flex-grow-1">
            <textarea pInputTextarea formControlName="comentario" class="form-control"
                [placeholder]="'Ingrese comentario'" rows="3">
            </textarea>
            <label>Comentario</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading">
            <mat-icon>save</mat-icon>
            {{ isEditMode ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
</form>